// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUi from 'element-ui'
import './assets/css/common.css'
import './assets/css/elementUi.css'
import './assets/css/table.css'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
import 'vue2-animate/dist/vue2-animate.min.css'
import _global from './assets/util/Global.vue'
import $ from 'jquery'

Vue.directive(
  "drag", //自定义指令 JS
  {
    bind: function(el, binding) {
      let oDiv = el; //当前元素

      oDiv.onmousedown = function(e) {
        //鼠标按下，计算当前元素距离可视区的距离
        e.preventDefault();
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function(e) {
          //通过事件委托，计算移动的距离
          let l = e.clientX - disX;
          let t = e.clientY - disY;

          //  控制拖拽范围

          // let pmaxX = oDiv.parentNode.offsetWidth;
          // let smaxX = oDiv.parentNode.childNodes[0].offsetWidth;

          // let pmaxY = oDiv.parentNode.offsetHeight;
          // let smaxY = oDiv.parentNode.childNodes[0].offsetHeight;

          // console.log(pmaxX, smaxX);
          // if (l < 0) {
          //   l = 0;
          // } else if (l > pmaxX - smaxX) {
          //   l = pmaxX - smaxX;
          // }

          // if (t < 0) {
          //   t = 0;
          // } else if (t > pmaxY - smaxY) {
          //   t = pmaxY - smaxY;
          // }

          //移动当前元素
          oDiv.style.left = l + "px";
          oDiv.style.top = t + "px";

          //将此时的位置传出去
          binding.value({ x: e.pageX, y: e.pageY });
        };
        document.onmouseup = function(e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    }
  }
);
import store from './store'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import commonMixin from '@/mixins/common'
Vue.mixin(commonMixin)

Vue.use(elementUi)
Vue.config.errorHandler = function(err, vm) {
    console.log('vue发生错误：', err)
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})
Vue.prototype.GLOBAL = _global //挂载到Vue实例上面



// WEBPACK FOOTER //
// ./src/main.js